__webpack_require__.p = "/React-Colour-Palette/";